import http from '@/utils/http';

const list = uid => http.apiGet(`/userInfo/${uid}`);

export default {
  list,
};
